/**
 * AddPatient 日期/年龄格式化 - 纯函数，无平台依赖
 */

export function formatDate(date: any, fmt: string): string {
  if (!date || !fmt) return String(date ?? '');
  if (typeof date === 'string' && date.length === 8) {
    date = `${date.substr(0, 4)}-${date.substr(4, 2)}-${date.substr(6, 2)}`;
  }
  if (typeof date !== 'number' && typeof date === 'string' && date.length <= 20) {
    date = date.replace(/-/g, '/');
  }
  const d = new Date(date);
  const o: Record<string, number> = {
    'M+': d.getMonth() + 1,
    'd+': d.getDate(),
    'h+': d.getHours(),
    'm+': d.getMinutes(),
    's+': d.getSeconds(),
    'q+': Math.floor((d.getMonth() + 3) / 3),
    S: d.getMilliseconds(),
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? String(o[k]) : ('00' + o[k]).substr(String(o[k]).length)
      );
    }
  }
  return fmt;
}

export function getAgeByBirthday(birthday: string, referDate = ''): number {
  if (!birthday) return 0;
  function parseDate(str: string): Date {
    const times = str.split('-');
    const date = new Date();
    date.setFullYear(parseInt(times[0], 10));
    date.setMonth(parseInt(times[1], 10) - 1);
    date.setDate(parseInt(times[2], 10));
    return date;
  }

  const today = referDate ? parseDate(referDate) : new Date();
  const todayYear = today.getFullYear();
  const todayMonth = today.getMonth() + 1;
  const todayDay = today.getDate();
  const bday = parseDate(birthday);
  const birthdayYear = bday.getFullYear();
  const birthdayMonth = bday.getMonth() + 1;
  const birthdayDay = bday.getDate();

  let age = todayYear - birthdayYear;
  if (todayMonth < birthdayMonth || (todayMonth === birthdayMonth && todayDay < birthdayDay)) {
    age--;
  }
  return age;
}
